'use client';
import { Space } from 'antd';
import DropDown from 'components/ui-new/DropDown';
import Toggle from 'components/ui-new/LanguageSelector/Toggle';
import { FC, useRef } from 'react';
import DropdownPlatform from './DropdownPlatform';
import { useDetectOutsideClick } from 'components/hooks/useDetectOutsideClick';

interface Props {
  className?: string;
}

const LanguageSelector: FC<Props> = ({ className }) => {
  const dropRef = useRef(null);
  const [isOpen, setIsOpen] = useDetectOutsideClick(dropRef, false);

  const handlerClose = (): void => {
    setIsOpen(false);
  };

  const handlerDropdownToggle = (): void => {
    setIsOpen((s) => !s);
  };

  return (
    <Space ref={dropRef} direction='vertical' className={className}>
      <Space wrap>
        <DropDown
          open={isOpen}
          overlayStyle={{ width: '300px' }}
          dropdownItem={<DropdownPlatform onClose={handlerClose} />}
          placement='bottomLeft'>
          <Toggle onClick={handlerDropdownToggle} isOpen={isOpen} />
        </DropDown>
      </Space>
    </Space>
  );
};

export default LanguageSelector;
